import React from 'react'
import { Box, Paper } from '@mui/material'
import TurnCup from '../TurnCup'
import { sheetAccent } from '../../sheetAccents'
import './Leaderboard.css'

/**
 * Leaderboard komponent der viser en rangliste over spillerne i Yatzy spillet
 * @param {Object} props - Komponentens props
 * @param {Array<Object>} players - Array af spillerobjekter med navn og point
 * @param {Function} calculateTotal - Funktion der beregner total point for en spiller
 * @param {Function} onPlayerClick - Funktion der kaldes når en spiller klikkes på
 * @param {number} tab - Index for den aktive spiller
 * @returns {JSX.Element} En visuel rangliste med spillerne sorteret efter point
 */
const Leaderboard = ({ players, calculateTotal, onPlayerClick, tab, turn }) => {
  return (
    <Paper 
      className="leaderboard-container"
      elevation={3}
      sx={{
        backgroundColor: 'var(--blured-field-color)',
        borderRadius: '16px',
        padding: '20px',
        color: '#f3eadf',
        height: 'fit-content',
        width: 'auto',
        boxSizing: 'border-box',
      }}
    >
      <Box 
        className="leaderboard-title"
      >
        Stilling
      </Box>
      <Box 
        className="leaderboard-players" 
      >
        {[...players]
          .sort((a, b) => calculateTotal(b) - calculateTotal(a))
          .map((player, index) => {
            const playerIndex = players.indexOf(player)
            const isActivePlayer = playerIndex === tab
            const isTurn = playerIndex === turn
            const isFirstPlace = index === 0
            
            return (
              <Box
                className={`leaderboard-player${isActivePlayer ? ' is-active' : ''}`}
                key={player.id || player.name}
                onClick={() => onPlayerClick && onPlayerClick(playerIndex)}
                style={{ '--player-accent': sheetAccent(playerIndex) }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '8px 12px',
                  borderRadius: '12px',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                }}
              >
              <Box className="leaderboard-player-emoji" >
                {index === 0 ? '👑' : 
                 index === 1 ? '🥈' : 
                 index === 2 ? '🥉' : 
                 index === players.length - 1 ? '💀' : 
                 '🎲'}
              </Box>
              <Box className="leaderboard-player-info" >
                <Box 
                  className="leaderboard-player-name"
                  sx={{
                    fontSize: '0.9em',
                    fontWeight: isActivePlayer || isFirstPlace ? 'bold' : 'normal',
                    color: isTurn || isActivePlayer || isFirstPlace
                      ? '#f0c27a'
                      : '#f3eadf'
                  }}>
                  {player.name}
                  {isTurn ? <TurnCup /> : null}
                </Box>
                <Box className="leaderboard-player-score" >
                  {calculateTotal(player)} point
                </Box>
              </Box>
            </Box>
            )
          })}
      </Box>
    </Paper>
  )
}

export default Leaderboard 